<template>
    <div>
        <!-- <hero></hero>
        <basic-elements></basic-elements>
        <inputs></inputs>
        <custom-controls></custom-controls>
        <navigation></navigation> -->
        <carousel></carousel>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 shape-red shape-skew">
                <!-- <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span> -->
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/ill/ill-2.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="fa fa-train" size="lg" class="bg-gradient-white" color="red" shadow rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h2 class="display-2 text-white">Classification Yard Automation</h2>
                                <p class="text-white lead">Innovation Reliability Robustness Modularity <br>
                                FlexYard & FlexTrim <br>
                                Process Control Systems</p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-cogs" gradient="red" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-red">FlexYard</h5>
                                    <p>3Z’s FlexYard process control system is one of our flagship products designed specifically for hump or flat switching classification yards. FlexYard has been built with capabilities superior to past and present competing technology, ensuring safety, reliability, and flexibility at low cost. </p>
                                    <router-link to="/flexyard" class="text-red">Take Control: Invest in Innovation >></router-link>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-cogs" gradient="primary" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-primary">FlexTrim</h5>
                                    <p>FlexTrim is one of 3Z’s other flagship products designed specifically as an eNtrance to eXit (NX) route lining system.</p>
                                    <router-link to="/flextrim" class="text-primary">Take Control: Building with Flexibility Results in Sustainability >></router-link>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-5 order-md-2">
                        <img src="img/3z/flexyard.png" class="img-fluid floating index-img">
                    </div>
                    <div class="col-md-7 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-settings-gear-65" class="mb-5" size="lg" shadow rounded color="red"></icon>
                            <h2 class="display-2 text-red">Innovative features</h2>
                            <p class="lead">Innovative, custom features not available in competing products such as HumpAnywherelogic, FlexDraw, FlexVoice, and complete remote accessibility to logs, reports, and diagnostics via web browsers sets FlexYard apart from competing products.</p>
                            <ul class="list-unstyled">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="fa fa-database"></badge>
                                        <h6 class="mb-0">HumpAnywhere Logic</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="warning" circle class="mr-3" icon="fa fa-globe"></badge>
                                        <h6 class="mb-0">GPS Time Sync</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="info" circle class="mr-3" icon="fa fa-volume-up"></badge>
                                        <h6 class="mb-0">FlexVoice–Speech Recognition Control and Audible Voice Alarms</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="fa fa-play-circle-o"></badge>
                                        <h6 class="mb-0">Workstation Screen Capture and Video Replay (Under Development)</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-darkred shadow border-0">
                            <img v-lazy="'img/3z/WebHome.jpeg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-darkred"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-darkred"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Web-based Technology</h4>
                                <p class="lead text-italic text-white">3Z’s FlexYard and FlexTrim control systems <br>
                                 are designed and deployed <br>with remote access capability. <br></p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <icon name="ni ni-settings" class="mb-5" size="lg"  shadow rounded color="red"></icon>

                            <h2 class="display-2 text-red">Web Based Logging & Reporting</h2>
                            <p class="lead">3Z’s FlexYard and FlexTrim control systems are designed and deployed with remote access capability. Event logs, system reports, daily reports, system health, component diagnostics, and alarm alerting are all accessed using web browsers.</p>
                            <!-- <p>Remote Access via Web BrowserFlexYard and FlexTrim Features and Capabilities.</p>
                            <p>Our online reports reflect state-of-the-art technology.</p> -->
                            <!-- <p>Accessibility: Remotely access event logs, customizable reports, and monitor system health diagnostics via web browser.</p> -->
                            <router-link to="/flexyard" class="font-weight-bold text-red
                             mt-5">Take Control: Expand Accessibility and Gain Viability >></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
</template>
<script>
// import Hero from "@/views/components/3Z/Hero";
// import BasicElements from "./components/BasicElements";
// import Inputs from "./components/Inputs";
// import CustomControls from "./components/CustomControls";
// import Navigation from "./components/3Z/Navigation";
import JavascriptComponents from "@/views/components/3Z/JavascriptComponents";
import Carousel from "@/views/components/3Z/Carousel";
import Icons from "./components/Icons";
import Examples from "./components/Examples";
import DownloadSection from "./components/DownloadSection";

export default {
  name: "Index",
  components: {
    // Hero,
    // BasicElements,
    // Inputs,
    // CustomControls,
    // Navigation,
    JavascriptComponents,
    Carousel,
    Icons,
    Examples,
    DownloadSection
  }
};
</script>
<style scoped>
.index-img {
    max-width: 160%;
    width: 160%;
}
</style>
